import Http from "../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../core/HttpResponse";
import { Form_Create_Dealer, Form_Update_Dealer } from "../../form/Form";
import { M_SubDealer } from "../../type/Dealer.type";

export const getSubDealers = async ({
  keyword,
  page,
  perPage,
}: HttpBaseRequest) => {
  const results = await Http.get<HttpBaseResponse<HttpData<M_SubDealer[]>>>({
    url: "/sub_dealer",
    params: {
      keyword,
      page,
      perPage,
    },
  });
  return results;
};

export const getSubDealer = async ({
  sub_dealer_id,
}: {
  sub_dealer_id?: string;
}) => {
  const results = await Http.get<HttpBaseResponse<M_SubDealer>>({
    url: "/sub_dealer/detail",
    params: {
      sub_dealer_id,
    },
  });
  return results;
};

export const addSubDealer = async ({
  sub_dealer_address,
  sub_dealer_name,
  sub_dealer_phone_number,
}: Form_Create_Dealer) => {
  const results = await Http.post({
    url: "/sub_dealer/insert",
    data: {
      sub_dealer_address,
      sub_dealer_name,
      sub_dealer_phone_number,
    },
  });
  return results;
};

export const updateSubDealer = async ({
  sub_dealer_address,
  sub_dealer_id,
  sub_dealer_name,
  sub_dealer_phone_number,
}: Form_Update_Dealer) => {
  const results = await Http.post({
    url: "/sub_dealer/update",
    data: {
      sub_dealer_address,
      sub_dealer_id,
      sub_dealer_name,
      sub_dealer_phone_number,
    },
  });
  return results;
};
